/// <amd-module name="VSS/Redux/Modules/TTIMonitor/TTIMonitorActions" />

import { createAction, ttiAction, ActionsUnion } from "redux/Utils/ActionHelper";

export const enum TTIMonitorActionTypes {
    AddSplit = "TTIMonitor/AddSplit",
    MarkTTI = "TTIMonitor/MarkTTI",
    // We want to set the isPageInteractive on next tick, that way anything scheduled post TTI will not happen until the first render
    // The reducer should listen to SetTTIState, and not MarkTTI
    SetTTIState = "TTIMonitor/SetTTIState",
    StartMeasure = "TTIMonitor/StartMeasure",
    EndMeasure = "TTIMonitor/EndMeasure"
}

export const TTIMonitorActions = {
    addSplit: (timingName: string) => ttiAction(createAction(TTIMonitorActionTypes.AddSplit, { timingName })),
    markTTI: (featureName: string, scenarioName: string, additionalProperties?: any) =>
        ttiAction(createAction(TTIMonitorActionTypes.MarkTTI, { featureName, scenarioName, additionalProperties })),
    setTTIState: () => createAction(TTIMonitorActionTypes.SetTTIState),
    startMeasure: (measureName: string) => ttiAction(createAction(TTIMonitorActionTypes.StartMeasure, { measureName })),
    endMeasure: (measureName: string) => ttiAction(createAction(TTIMonitorActionTypes.EndMeasure, { measureName }))
};

export type TTIMonitorActions = ActionsUnion<typeof TTIMonitorActions>;
